import React, { Component } from 'react'

export default class HotsheetDisplayOptions extends Component {

  static defaultProps = {
    defaultSelected: 'standard'
  }

  render() {
    const { name, defaultSelected: sel, autoNext } = this.props

    return (
      <div className="hotsheet-display-options">
        <div>
          <label>
            <div>
              <input type="radio" name={name} value="standard" defaultChecked={sel === 'standard'} />
              <div>
                <div><strong>Grid</strong></div>
                <div><small>Standard Search Result</small></div>
              </div>
            </div>
            <img src="/images/hotsheet_display_options/grid.jpg" />
          </label>
        </div>
        <div>
          <label>
            <div>
              <input type="radio" name={name} value="list" defaultChecked={sel === 'list'} />
              <div>
                <div><strong>List</strong></div>
                <div><small>Full Width Results with description</small></div>
              </div>
            </div>
            <img src="/images/hotsheet_display_options/list.jpg" />
          </label>
        </div>
        <div>
          <label>
            <div>
              <input type="radio" name={name} value="gallery" defaultChecked={sel === 'gallery'} />
              <div>
                <div><strong>Gallery</strong></div>
                <div><small>Scrollable results in a single row</small></div>
              </div>
            </div>
            <img src="/images/hotsheet_display_options/gallery.jpg" />
          </label>
          <label style={{ textAlign: 'center', fontSize: '12px' }}>
              <input type="checkbox" defaultChecked={autoNext} name="auto_next" style={{ display: 'inline', width: 'auto', marginLeft: '0', marginRight: '5px' }} />
              Automatically Scroll Results
          </label>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Hotsheets/DisplayOptions.js